export default "__VITE_ASSET__Dk23wYYP__"